import { injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import TableHeader from "src/components/TableHeader";
import { STRATEGY_TABLE_TITLE_SORT, STRATEGY_TABLE_TITLE_WIDTHS, STRATEGY_TABLE_TITLES } from "src/helpers/Constants";
import { OperationType, StrategyTableSortType } from "src/helpers/Enums";
import Pagination from "src/components/Pagination";

const StrategyTable = (props) => {

    const [sortedList, setSortedList] = useState(props.list)
    const [currentPage, setCurrentPage] = useState(1)
    const totalPages = 1

    useEffect(() => {
        setSortedList(props.list)
    }, [props.list])

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className={ "w-full flex flex-col justify-between h-full" }>
            <div className={ "w-full flex flex-col gap-3" }>
                <TableHeader titles={ STRATEGY_TABLE_TITLES } widths={ STRATEGY_TABLE_TITLE_WIDTHS }
                             sort={ STRATEGY_TABLE_TITLE_SORT } sortedList={ sortedList }
                             sortType={ StrategyTableSortType }
                             setSortedList={ setSortedList }/>
                <div className="TableWrapper">
                    <table className="Table">
                        <tbody>
                        { sortedList?.map((item, index) => (
                            <tr key={ index } className="border-b h-[60px] hover:bg-[#F6F6F9]">
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: STRATEGY_TABLE_TITLE_WIDTHS[0]} }>{ item.name }</td>
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: STRATEGY_TABLE_TITLE_WIDTHS[2]} }>{ item.top_offer }</td>
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: STRATEGY_TABLE_TITLE_WIDTHS[3]} }>{ item.new_offer }</td>
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: STRATEGY_TABLE_TITLE_WIDTHS[4]} }>{ item.old_winner }</td>
                                <td className="py-3 px-4 flex justify-center items-center">
                                    <button className="StrategyEditButton"
                                            onClick={ () => props.handleOpenNewStrategy(OperationType.UPDATE, item) }>
                                        <img alt={ "Logo" } src={ "/media/icons/editIcon.svg" }
                                             className={ "w-4 h-4" }/>
                                        Edit
                                    </button>
                                    <button className="StrategyDeleteButton"
                                            onClick={ () => props.handleOpenDeleteStrategy(item) }>
                                        <img alt={ "Logo" } src={ "/media/icons/deleteIcon.svg" }
                                             className={ "w-4 h-4" }/>
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        )) }
                        </tbody>
                    </table>
                </div>
            </div>
            <Pagination currentPage={ currentPage } totalPages={ totalPages } onPageChange={ handlePageChange }/>
        </div>
    );
}

export default injectIntl(StrategyTable);
